import * as angular from "angular";
import {IController, IQService, ITimeoutService} from "angular";
import * as _ from "lodash"
import {DataSet} from "vis-data";
import {TaskStatusType} from "../../../tasks/types/taskStatus.type";
import {BringozTimelineService} from "../../../commons/services/bringoz-timeline-service.service";

export class AgentsPerformanceTimelineComponent implements IController {
  agents: any;
  tasks: any;
  irregularities: any;
  date: string;
  isStack: boolean;
  selectedItemId: any;
  workingSlots: any[];
  onViewService: Function;
  onRightClickTask: Function;
  onTimestampChange: Function;

  private container: any;
  private vis: any;
  private rrule: any;
  private options: any;
  private timeline: any;
  private tableHeaderDivRef: any;
  private groupsDataSet: any;
  private itemsDataSet: any;

  /////////////////// ICONS ///////////////////
  private iconsUrl: any;
  private readonly $agentOnDutyIcon: any;
  private readonly $agentOffDutyIcon: any;
  private $routedRowIcon: any;

  constructor(private $q: IQService, private $filter, private $timeout: ITimeoutService, private moment, private bringozTimelineService: BringozTimelineService) {

    this.vis = require('vis-timeline');

    this.rrule = require('rrule');


    this.iconsUrl = {
      onDuty: 'assets/images/icons/v2/on-duty.svg',
      offDuty: 'assets/images/icons/v2/off-duty.svg',
      routed: 'assets/images/icons/v2/route.svg',
    }

    this.$agentOnDutyIcon = document.createElement('IMG');
    this.$agentOnDutyIcon.setAttribute("src", this.iconsUrl.onDuty);
    this.$agentOnDutyIcon.classList.add('bringoz-icon');

    this.$agentOffDutyIcon = document.createElement('IMG');
    this.$agentOffDutyIcon.setAttribute("src", this.iconsUrl.offDuty);
    this.$agentOffDutyIcon.classList.add('bringoz-icon');

    this.$routedRowIcon = document.createElement('IMG');
    this.$routedRowIcon.setAttribute("src", this.iconsUrl.routed);
    this.$routedRowIcon.classList.add('bringoz-icon-small');

  }

  $onInit() {

    // create visualization
    this.container = document.getElementById('timeline');

    // Set Timeline
    this.groupsDataSet = new DataSet()
    this.itemsDataSet = new DataSet()

    // Set Options
    this.options = {
      // option groupOrder can be a property name or a sort function
      // the sort function must compare two groups and return a value
      //     > 0 when a > b
      //     < 0 when a < b
      //       0 when a == b
      groupOrder: (a, b) => {
        return a.value - b.value;
      },
      groupOrderSwap: (groupDragged, groupToSwap, groups) => {
        const value = groupDragged.value;
        groupDragged.value = groupToSwap.value;
        groupToSwap.value = value;
      },
      groupTemplate: (group) => {
        return '';
      },
      snap: (date, scale, step) => {
        const fifteenMinutes = 60 * 1000; // ticks of 15 minutes
        return Math.round(date / fifteenMinutes) * fifteenMinutes;
      },
      orientation: 'top',
      editable: false,
      selectable: false,
      xss: {
        disabled: true,
        // filterOptions: {
        //   whiteList: { p: ['class', 'data-from-template'], div: 'class' },
        // },
      },
      verticalScroll: false,
      zoomKey: 'ctrlKey',
      width: '100%',
      height: '100%',
      // margin: {
      //   item: 5
      // },
      stack: false,
      // stackSubgroups: false,
      tooltip: {
        followMouse: true
      },
      // maxMinorChars: 5,
      start: this.moment(this.date).startOf('day'),
      end: this.moment(this.date).endOf('day'),
      min: this.moment(this.date).startOf('day'),
      max: this.moment(this.date).endOf('day'),
      zoomMin: 1080000, // Zoom In Max 5 Mins
      // zoomMax: 18800000 // Zoom Out Max 1 Hour,
      horizontalScroll: true,
    };

    this.timeline = new this.vis.Timeline(this.container, [], this.options);

    this.initCustomBar();

    this.timeline.itemSet.groupHammer.off('tap');

    // Set Table Actions
    const topElementRef = this.timeline.body.dom.top;
    topElementRef.style = 'left: 0px';
    this.tableHeaderDivRef = document.createElement("div");
    this.tableHeaderDivRef.classList.add("resources-list-header-container");

    // var addResourceButton = document.createElement('md-button');
    // addResourceButton.classList.add("md-raised", "md-accent");
    // addResourceButton.innerHTML = '+ ' +  $filter('translate')('Add Resource');
    // tableHeaderDivRef.appendChild(addResourceButton);

    topElementRef.before(this.tableHeaderDivRef);

    // Set Timeline
    this.timeline.setGroups(this.groupsDataSet);
    this.timeline.setItems(this.itemsDataSet);

    // Init Groups
    this._initTimelineData(this.agents);

    let itemsToAdd = [];
    // Init Items Data
    itemsToAdd = itemsToAdd.concat(this._getTasksItemsData(this.tasks));
    itemsToAdd = itemsToAdd.concat(this._getTaskStatusesItemsData(this.tasks));
    itemsToAdd = itemsToAdd.concat(this._getWorkingSlotItemsData(this.workingSlots));

    if (!!this.irregularities?.length && !!this.tasks?.length) {
      itemsToAdd = itemsToAdd.concat(this._getIrregularitiesItemsData(this.irregularities));
    }


    if (itemsToAdd.length) {
      this.itemsDataSet.add(itemsToAdd);
    }
    // Click Event
    this.timeline.on('click', (properties) => {
      if (properties.what === "group-label" && !properties.group.includes("routes-")) {
        this._toggleGroupRoutes(properties.group);
      }
    });

    // Double Click Event
    this.timeline.on('doubleClick', (properties) => {
      if (_.get(properties, 'item')) {
        const item = this.itemsDataSet.get(properties.item);
        if (_.get(item, 'serviceId')) {
          this.onViewService({id: item.serviceId});
        }
      }
    });

    // Right Click Event
    this.timeline.on('contextmenu', (properties) => {
      if (_.get(properties, 'item')) {
        const event = properties.event;
        const item = this.itemsDataSet.get(properties.item);
        this._onClicked().then(() => {
          this.onRightClickTask({task: item.ref, event: event});
        })
      }
      properties.event.preventDefault();
    });
  }

  private initCustomBar() {
    let customTime = this.moment(this.date).endOf('day').subtract(15, 'minute').valueOf();
    let customTimeId = 'myCustomTime';
    this.timeline.addCustomTime(customTime, customTimeId);

    let customTimeBar = this.timeline.getCustomTime(customTimeId);
    let customTimeIcon = document.createElement('div');
    customTimeIcon.className = 'custom-time';
    customTimeIcon.innerHTML = `<div class="custom-time-icon">
<svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.4566 3.64266C14.1575 3.1435 13.61 2.8335 13.0283 2.8335H11V1.16683C11 0.705996 10.6275 0.333496 10.1666 0.333496H1.83329C0.914126 0.333496 0.166626 1.081 0.166626 2.00016V10.3335C0.166626 10.9552 0.513293 11.4927 1.01913 11.7785C1.12163 13.2943 2.37496 14.5002 3.91663 14.5002C5.38246 14.5002 6.58663 13.4093 6.79079 12.0002H9.37579C9.57996 13.4093 10.7841 14.5002 12.25 14.5002C13.7158 14.5002 14.92 13.4093 15.1241 12.0002H15.1666C16.0858 12.0002 16.8333 11.2527 16.8333 10.3335V7.8335C16.8333 7.68183 16.7925 7.53433 16.7141 7.40433L14.4566 3.64266ZM11 4.50016H13.0283L14.5283 7.00016H11V4.50016ZM3.91663 12.8335C3.22746 12.8335 2.66663 12.2727 2.66663 11.5835C2.66663 10.8943 3.22746 10.3335 3.91663 10.3335C4.60579 10.3335 5.16663 10.8943 5.16663 11.5835C5.16663 12.2727 4.60579 12.8335 3.91663 12.8335ZM12.25 12.8335C11.5608 12.8335 11 12.2727 11 11.5835C11 10.8943 11.5608 10.3335 12.25 10.3335C12.9391 10.3335 13.5 10.8943 13.5 11.5835C13.5 12.2727 12.9391 12.8335 12.25 12.8335Z" fill="
#266AFF"/>
</svg>

</div>`;
    this.container.appendChild(customTimeIcon);

    const updateIconPosition = () => {
      const customTimePosition = this.timeline.getCustomTime(customTimeId);

      // Calculate the width of the group area
      const groupAreaWidth: any = document.querySelector('.vis-panel.vis-left');

      // Convert the time value to screen coordinate
      let leftPosition = this.timeline._toScreen(customTimePosition) - customTimeIcon.offsetWidth / 2;

      // Adjust for the group area offset
      leftPosition += groupAreaWidth.offsetWidth;

      // Update the icon's left position
      customTimeIcon.style.left = leftPosition + 'px';
    }

    this.$timeout(300).then(() => {
      const customTimeElement = this.container.querySelector('.vis-custom-time');
      if (customTimeElement) {
        customTimeElement.style.pointerEvents = 'none';
      }
      updateIconPosition(); // Set initial position
    })

    customTimeIcon.addEventListener('mousedown', (event) => {
      event.preventDefault();

      var initialX = event.clientX;

      const onMouseMove = (event) => {

        const deltaX = event.clientX - initialX;
        initialX = event.clientX;

        // Calculate the new time based on deltaX and timeline range
        const container = document.getElementById('timeline');
        let newTime = this.timeline.getCustomTime(customTimeId).getTime() + deltaX * (this.timeline.range.end - this.timeline.range.start) / container.clientWidth;
        const minTime = this.timeline.range.start.valueOf();
        const maxTime = this.timeline.range.end.valueOf();

        // Ensure the new time is within the valid range
        if (newTime < minTime) {
          newTime = minTime;
        } else if (newTime > maxTime) {
          newTime = maxTime;
        }

        // Set the new custom time
        this.timeline.setCustomTime(new Date(newTime), customTimeId);
        this.onTimestampChange({timestamp: this.moment(this.timeline.getCustomTime(customTimeId)).valueOf()});


        // Update the icon's position
        updateIconPosition();
      }

      const onMouseUp = () => {
        // const finalTime = this.timeline.getCustomTime(customTimeId);
        // this.onTimestampChange({timestamp: this.moment(this.timeline.getCustomTime(customTimeId)).valueOf()});
        document.removeEventListener('mousemove', onMouseMove);
        document.removeEventListener('mouseup', onMouseUp);
      }

      document.addEventListener('mousemove', onMouseMove);
      document.addEventListener('mouseup', onMouseUp);
    });

    // Update icon position when timeline range changes (e.g., on zoom or pan)
    this.timeline.on('rangechange', updateIconPosition);
  }

  $onChanges(changes: angular.IOnChangesObject) {

    if (changes.agents && !changes.agents.isFirstChange()) {
      this.groupsDataSet.clear();
      this.groupsDataSet.add(this._getGroupsData(this.agents));
      this.$timeout(300).then(() => {
        this._setExpandedGroupsRoutes();
      })
    }

    if ((changes.tasks && !changes.tasks.isFirstChange()) || (changes.workingSlots && !changes.workingSlots.isFirstChange()) ||
      (changes.irregularities && !changes.irregularities.isFirstChange())) {
      this.itemsDataSet.clear();

      // Init Items Data
      let itemsToAdd = [];
      itemsToAdd = itemsToAdd.concat(this._getTasksItemsData(this.tasks));
      itemsToAdd = itemsToAdd.concat(this._getTaskStatusesItemsData(this.tasks));
      itemsToAdd = itemsToAdd.concat(this._getWorkingSlotItemsData(this.workingSlots));

      if (!!this.irregularities?.length && !!this.tasks?.length) {
        itemsToAdd = itemsToAdd.concat(this._getIrregularitiesItemsData(this.irregularities));
      }

      if (itemsToAdd.length) {
        this.$timeout(0).then(() => {
          this.itemsDataSet.add(itemsToAdd);
        })
      }

    }

    if (changes.selectedItemId && !changes.selectedItemId.isFirstChange()) {
      const selectedTask = this._getSelectedItem(this.selectedItemId);
      if (selectedTask) {
        this.timeline.setSelection(selectedTask.id);
      } else {
        this.timeline.setSelection(undefined);
      }
    }

    if (changes.date && !changes.date.isFirstChange()) {
      const start = this.moment(this.date).startOf('day');
      const end = this.moment(this.date).endOf('day');

      this.options.min = start;
      this.options.max = end;
      this.timeline.setOptions(this.options);
      this.timeline.setWindow(start.toDate(), end.toDate());

      // this.initCustomBar();
      let customTime = this.moment(this.date).endOf('day').subtract(15, 'minute').valueOf();;
      let customTimeId = 'myCustomTime';
      this.timeline.addCustomTime(customTime, customTimeId);
    }
  }


  // ******************************
  //        Public methods
  // ******************************

  public onFit() {
    this.timeline.fit();
  }

  private onZoom(isZoomIn) {
    isZoomIn ? this.timeline.zoomIn(0.5) : this.timeline.zoomOut(0.5);
  }

  // ******************************
  //        Private methods
  // ******************************

  private _getGroupsData(agents) {

    const itineraryGroups = [];

    _.forEach(agents, (a, index) => {
      itineraryGroups.push(this._getAgentGroups(a, index));
    })

    return _.concat(itineraryGroups);
  }

  private _getTasksItemsData(tasks) {

    return _.map(tasks, (task, index) => {
      const groupId = task.agentId;

      let taskEta = task.agentHeadingTime || task.agentArrivalTime;
      let taskEtd = task.agentDepartureTime || task.statusUpdatedAt;

      const taskPurpose = task.taskSpec.purpose;

      return {
        ref: task,
        id: task.id,
        status: task.status,
        start: this.moment(taskEta),
        end: this.moment(taskEtd),
        startTime: this.moment(taskEta),
        endTime: this.moment(taskEtd),
        purpose: taskPurpose,
        taskIdList: _.get(task, 'taskIdList'),
        taskType: task.taskType,
        serviceId: task.serviceId,
        serviceIds: task.bundleServiceIdList,
        group: task.agentId,
        agentId: groupId,
        routeId: task.routeId,
        taskId: task.id,
        className: `task ${task.taskSpec.purpose}`,
        // title: this.bringozTimelineService.getItineraryTaskOrientedTimelineItemTooltip(task, taskEtaWindow, relations, taskIndex),
        // content: this._getTaskContent(task, taskAgentHeadingTime, taskEta, taskEtd, taskIndex),
      }
    });

  }


  private _getTaskStatusesItemsData(tasks) {
    const items = [];

    _.forEach(tasks, (task, index) => {

      if (task.status === TaskStatusType.Canceled) {
        const abortedTaskStatus = {
          start: this.moment(task.statusUpdatedAt),
          editable: false,
          id: `aborted-${task.id}`,
          group: task.agentId,
          type: 'point',
          className: 'task-status aborted',
          content: '<span class="br-body-2 font-weight-400 primary-300 font-weight-600">' + 'A' + (index + 1) + '</span>'
        };

        items.push(abortedTaskStatus);
      }

      if (task.agentHeadingTime) {
        const headingTaskStatus = {
          start: this.moment(task.agentHeadingTime),
          editable: false,
          id: `heading-${task.id}`,
          group: task.agentId,
          type: 'point',
          className: 'task-status heading',
          content: '<span class="br-body-2 font-weight-400 primary-300 font-weight-600">' + 'H' + (index + 1) + '</span>'
        };

        items.push(headingTaskStatus);
      }

      if (task.agentArrivalTime) {
        const arrivalTaskStatus = {
          start: this.moment(task.agentArrivalTime),
          editable: false,
          id: `arrival-${task.id}`,
          group: task.agentId,
          type: 'point',
          className: 'task-status arrival',
          content: '<span class="br-body-2 font-weight-400 primary-300 font-weight-600">' + 'A' + (index + 1) + '</span>'
        };

        items.push(arrivalTaskStatus);
      }

      if (task.agentDepartureTime) {
        const departureTaskStatus = {
          start: this.moment(task.agentDepartureTime),
          editable: false,
          id: `departure-${task.id}`,
          group: task.agentId,
          type: 'point',
          className: 'task-status departure',
          content: '<span class="br-body-2 font-weight-400 primary-300 font-weight-600">' + 'C' + (index + 1) + '</span>'
        };

        items.push(departureTaskStatus);
      }
    })

    return items;
  }

  private _getIrregularitiesItemsData(irregularities) {
    const items = [];

    irregularities.forEach((agentIrregularties) => {
      agentIrregularties.outOfServiceArea?.forEach((item) => {
        const irregularity = {
          start: this.moment(item.fromDate),
          editable: false,
          id: `outOfServiceArea-${item.fromDate}`,
          group: agentIrregularties.agentId,
          type: 'point',
          className: 'irregularity',
          title: this.bringozTimelineService.getAgentIrregularityTooltip(item, 'outOfServiceAreaIrregularity'),
          content: '<span></span>'
        };

        items.push(irregularity);
      })

      agentIrregularties.completionDistanceFromTaskLocation?.forEach((item) => {

        const task = this.tasks.find((t) => t.id === item.taskId);

        const irregularity = {
          start: this.moment(task.agentDepartureTime),
          editable: false,
          id: `completionLocationIrregularity-${item.taskId}`,
          group: agentIrregularties.agentId,
          type: 'point',
          className: 'irregularity',
          title: this.bringozTimelineService.getAgentIrregularityTooltip(item, 'taskCompletionLocationIrregularity'),
          content: '<span></span>'
        };

        items.push(irregularity);
      })
    })

    return items;
  }

  private _initTimelineData(agents) {
    const groups = this._getGroupsData(agents);

    this.groupsDataSet.add(groups);
  }

  private _onClicked() {
    const deferred = this.$q.defer();
    deferred.resolve();
    return deferred.promise;
  }

  private _getSelectedItem(id) {

    if (!id) {
      return undefined;
    }

    const selectedItem = this.itemsDataSet.get({
      filter: (item) => {
        return item.id === id;
      }
    });
    return this.itemsDataSet.get(selectedItem[0] ? selectedItem[0].id : undefined)
  }

  private _setExpandedGroupsRoutes() {
    const updatedGroups = [];

    this.groupsDataSet.forEach((group) => {
      group.showNested = true;
      updatedGroups.push(group);
    });

    this.groupsDataSet.update(updatedGroups);
  }

  private _toggleGroupRoutes(groupId) {
    const updatedGroups = [];

    this.groupsDataSet.forEach((group) => {
      if (group.id === groupId) {
        group.showNested = !group.showNested;
      }
      updatedGroups.push(group);
    });

    this.groupsDataSet.update(updatedGroups);
  }

  private _getAgentGroups(a, index) {
    return {
      ref: a,
      id: a.id,
      skills: a.skills,
    }
  }

  private _getWorkingSlotItemsData(workingSlots) {
    let items = [];

    _.forEach(workingSlots, (w) => {

      if (w.in) {
        items.push(this._getWorkingSlotClockInItemData(w));
        items.push(this._getWorkingSlotBackgroundData(w));
      }

      if (w.out) {
        items.push(this._getWorkingSlotClockOutItemData(w));
      }

    });

    return items;
  }

  private _getWorkingSlotClockInItemData(workingSlot) {
    return {
      id: 'clock-in' + workingSlot.id,
      ref: workingSlot,
      group: workingSlot.agentId,
      agentId: workingSlot.agentId,
      start: this.moment(workingSlot.in.time),
      startTime: this.moment(workingSlot.in.time).valueOf(),
      type: 'point',
      itemType: 'WORKING_SLOT',
      className: 'clock-in',
      title: (workingSlot.in?.time && workingSlot.out?.time) ?
        '<span class="br-body-1">' + this.$filter('timeWindow')({
          notBefore: workingSlot.in.time,
          notAfter: workingSlot.out.time
        }) + '</span>' :
        '<span class="br-body-1">' + this.$filter('translate')('Clock In') + ' ' + this.$filter('bringozDate')(workingSlot.in, 'time', true) + '</span>',
    }
  }

  private _getWorkingSlotBackgroundData(workingSlot) {
    return {
      id: 'background' + workingSlot.id,
      ref: workingSlot,
      group: workingSlot.agentId,
      agentId: workingSlot.agentId,
      start: this.moment(workingSlot.in.time),
      end: this.moment(workingSlot.out?.time),
      startTime: this.moment(workingSlot.in.time).valueOf(),
      endTime: this.moment(workingSlot.out?.time).valueOf(),
      type: 'background',
      itemType: 'WORKING_SLOT',
      className: 'working-slot'
    }
  }

  private _getWorkingSlotClockOutItemData(workingSlot) {
    return {
      id: 'clock-out' + workingSlot.id,
      ref: workingSlot,
      group: workingSlot.agentId,
      agentId: workingSlot.agentId,
      start: this.moment(workingSlot.out.time),
      startTime: this.moment(workingSlot.out.time).valueOf(),
      type: 'point',
      itemType: 'WORKING_SLOT',
      className: 'clock-out',
      title: (workingSlot.in?.time && workingSlot.out?.time) ?
        '<span class="br-body-1">' + this.$filter('timeWindow')({
          notBefore: workingSlot.in.time,
          notAfter: workingSlot.out.time
        }) + '</span>' :
        '<span class="br-body-1">' + this.$filter('translate')('Clock Out') + ' ' + this.$filter('bringozDate')(workingSlot.out, 'time', true) + '</span>'
    }
  }

  $onDestroy() {
    if (this.timeline) {
      this.timeline.destroy();
      this.timeline = null;
    }
    if (this.itemsDataSet) {
      this.itemsDataSet.clear();
      this.itemsDataSet = null;
    }
    if (this.groupsDataSet) {
      this.groupsDataSet.clear();
      this.groupsDataSet = null;
    }
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentsPerformanceTimeline', {
      bindings: {
        agents: '<',
        tasks: '<',
        irregularities: '<',
        workingSlots: '<?',
        date: '<',
        isStack: '<?',
        colorByLate: '<?',
        selectedItemId: '<',
        onViewService: '&',
        onRightClickTask: '&',
        onTimestampChange: '&'
      },
      template: require('./agents-performance-timeline.html').default,
      controller: AgentsPerformanceTimelineComponent
    }
  );
